<template>
  <div>
    <vs-popup-custom
      classContent="popup-example"
      :title="title"
      :persistent="disableClose"
      :active.sync="popupActivo"
    >
      <upload-other-files ref="otherFiles" @update="updateFiles" class="mb-4" />
      <div class="flex flex-wrap">
        <div class="w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 ml-auto mr-auto">
          <vs-button
            type="filled"
            color="danger"
            class="w-full mx-4"
            :disabled="!expenseFiles.status"
            icon-pack="feather"
            icon="icon-send"
            @click="sendFiles"
          >
            Enviar
          </vs-button>
        </div>
      </div>
    </vs-popup-custom>
  </div>
</template>

<script>
import UploadOtherFiles from './UploadOtherFiles.vue'
import VsPopupCustom from '@/components/modals/VsPopupCustom.vue'
import vendor from '@/http/requests/vendor/index.js'
export default {
  components: {
    UploadOtherFiles,
    VsPopupCustom,
  },
  props:{
    expenseId:{
      type:String,
      required:true
    }
  },
  data() {
    return {
      expenseFiles: {
        status: false,
        files:[]
      },
      title: 'Cargar Archivos',
      popupActivo:false,
      disableClose: true,
    }
  },
  methods: {
    open() {
      this.popupActivo = true
      this.showAlert = false
      this.$refs.otherFiles.restart()
    },
    updateFiles(e) {
      this.expenseFiles = { ...e }
    },
    sendFiles() {
     this.$vs.loading()
      const data = new FormData()
      const vendorData = JSON.parse(localStorage.getItem('vendor'))
      data.append('vendor_id', vendorData.VendorId)
      data.append('expense_id', this.expenseId)
      this.expenseFiles.files.forEach(function (file, i) {
        data.append('files[]', file)
      })
      vendor
        .uploadFiles(data)
        .then((res) => {
          this.$vs.loading.close()
          if (res.data.status == true) {
            this.$vs.notify({
              color: 'success',
              title: 'Success',
              text: res.data.msg,
            })
            this.popupActivo = false
            this.$emit('success')
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Error',
              text: res.data.msg,
            })
          }
        })
        .catch((err) => {
          if (422 === err.response.status) {
            this.msg = err.response.data.msg
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Alert',
              text: 'SERVER ERROR',
            })
          }
          this.$vs.loading.close()
        })
    },
  },
}
</script>

<style>
@media (min-width: 992px) {
  .con-vs-popup .vs-popup {
    width: 70vw;
  }
}
</style>
